import { KYMW1402Component } from './kymw1402.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 誌面印刷画面の値を管理するクラス
 *
 * @export KYMW1402Model
 * @class KYMW1402Model
 */
export class KYMW1402Model {

  kymw1402Component: KYMW1402Component;

  /* 検索条件 */
  // 受注コード
  public orderCode = String('');
  // 媒体
  public mediumType = String('');

  /** ページ一覧Array */
  public pageList: Array<any> = new Array<any>();

  // 全
  public chkAllCoop = Boolean(false);
  // いばらき
  public chkIbaraki = Boolean(false);
  // とちぎ
  public chkTochigi = Boolean(false);
  // ぐんま
  public chkGunma = Boolean(false);
  // ちば
  public chkChiba = Boolean(false);
  // さいたま
  public chkSaitama = Boolean(false);
  // とうきょう
  public chkTokyo = Boolean(false);
  // ながの
  public chkNagano = Boolean(false);
  // にいがた
  public chkNiigata = Boolean(false);

  // コマ情報の表示
  public chkShowKoma = Boolean(true);
  // 商品情報の表示
  public chkShowGoods = Boolean(true);
  // 画像の表示
  public chkShowImage = Boolean(true);

  // 表示ボタン非活性フラグ
  public disabledDisplay = Boolean(true);

  /**
   * ページ一覧を生成
   *
   * @param {*} serverData サーバからの受信データ
   * @memberof KYMW1402Model
   */
  public setPrintPageData(serverData: any): void {
    if (serverData != null && serverData.length !== 0) {
      this.pageList = serverData;

      for (let i = Number(0); i < this.pageList.length; i++) {
        this.pageList[i].PageNum = this.pageNumFormat(this.pageList[i].PageNum);
        this.pageList[i].Selected = this.pageList[i].Selected === true;
      }
    }
  }

  /**
   * ページ一覧をクリア
   *
   * @memberof KYMW1402Model
   */
  public pageListClear(): void {
    this.pageList = new Array<any>();
  }

  /**
   * ページ情報のチェックボックスを一括設定する
   *
   * @param {boolean} mode チェック状態
   * @memberof KYMW1402Model
   */
  public changeCheckMode(mode: boolean): void {
    for (let i = Number(0); i < this.pageList.length; i++) {
      this.pageList[i].Selected = mode;
    }
  }

  /**
   * ページ番号を3桁でフォーマットする
   *
   * @private
   * @param {string} str 文字列
   * @returns {string} ゼロパディング(3桁)した文字列
   * @memberof KYMW1402Model
   */
  private pageNumFormat(str: string): string {
    if (PlessViewUtilsSub.isEmpty(str)) {
      return '';
    } else {
      str = PlessViewUtilsSub.zeroPadding(3, str);
      return str;
    }
  }
}
